import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getCustomerTimeline } from '../../services/customers';

function useGetCustomerTimeline({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const query = useInfiniteQuery({
    queryKey: ['customer-timeline', { customerId, businessId }],
    queryFn: ({ pageParam }) =>
      getCustomerTimeline({ customerId, businessId, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    enabled: !!customerId && !!businessId,
  });

  const pages = query.data?.pages;
  const entries = useMemo(
    () => pages?.flatMap(page => page.entries) ?? [],
    [pages],
  );

  return {
    entries,
    isInitialLoading: query.isPending,
    isFetchingNextPage: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: () => {
      query.fetchNextPage();
    },
    error: query.error,
  };
}

export default useGetCustomerTimeline;
